<div class="content-table" style="max-height: initial">
  <p class="empty" *ngIf="isEmpty">No se encontraron datos</p>
  <p class="text_title">Alerta Urgente - Historial de Strike por alerta</p>
  <table
    *ngIf="!isEmpty"
    style="text-align: center"
    mat-table
    matSort
    [dataSource]="dataSource"
  >
    <ng-container matColumnDef="user">
      <th class="center" mat-header-cell *matHeaderCellDef>Usuario</th>
      <td class="paddingLR" mat-cell *matCellDef="let element">
        {{ element.user.fullname }}
      </td>
    </ng-container>

    <ng-container matColumnDef="gai">
      <th class="center" mat-header-cell mat-sort-header *matHeaderCellDef>
        Alerta
      </th>
      <td class="paddingLR" mat-cell *matCellDef="let element">
        {{ element.alert.gai }}
      </td>
    </ng-container>
    <ng-container matColumnDef="count">
      <th class="center" mat-header-cell *matHeaderCellDef>Strikes</th>
      <td class="paddingLR" mat-cell *matCellDef="let element">
        {{ element.count }}
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<mat-paginator
  #paginator
  *ngIf="barDataPriority?.length > 5"
  [pageSizeOptions]="[5]"
  [pageSize]="5"
  [showFirstLastButtons]
></mat-paginator>
<!-- <div class="content-status-bar">
  <div class="textTitles">
    <p class="title">Strikes por usuarios</p>
  </div>
  <div *ngFor="let data of barDataPriority">
    <div class="divProgress">
      <p class="titleAmount">{{ data.user.fullname }}({{ data.count }})</p>
      <div class="divPercentage">
        <mat-progress-bar
          [ngClass]="data.priority"
          [color]="data.color"
          [value]="((data.count * 100) / total).toFixed()"
        >
        </mat-progress-bar>
        <p>{{ ((data.count * 100) / total).toFixed(2) }}%</p>
      </div>
    </div>
    <div class="separatorLine"></div>
  </div>
</div> -->
